/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import { enableScrollDepthTracking } from "./src/utils/analytics"

const recaptchaSiteKey = (process.env.GATSBY_RECAPTCHA_SITE_KEY || "")
  .trim()
  .replace(/^["']|["']$/g, "")

export const wrapRootElement = ({ element }) => {
  if (!recaptchaSiteKey) {
    return element
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      {element}
    </GoogleReCaptchaProvider>
  )
}

export const onInitialClientRender = () => {
  enableScrollDepthTracking()
}
